import { useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { useLogin } from "../../hooks/mutations/useLogin";
import { useAuth } from "../../contexts/AppContext";
import Loading from "../../components/Loading";
import colors from "../../styles/colors";

import { setTitle } from "../../services/browser";

import logoEgam from "../../assets/images/logo-egam-login.png";

import { Container, Card, LogosContainer, Content, Message } from "./styles";

const Login = () => {
  const navigate = useNavigate();
  const { token, coreIndustry } = useParams<{
    token?: string;
    coreIndustry?: string;
  }>();

  const { loggedIn, loading: loadingAuth } = useAuth();
  const loginMutation = useLogin();

  const isLoading = loadingAuth || loginMutation.isPending;

  useEffect(() => {
    if (
      !loggedIn &&
      token &&
      coreIndustry &&
      !loginMutation.isPending &&
      !loginMutation.isError
    ) {
      loginMutation.mutate({ token, coreIndustry });
    }
  }, [
    loggedIn,
    token,
    coreIndustry,
    loginMutation.isPending,
    loginMutation.isError,
  ]);

  useEffect(() => {
    if (!isLoading && loggedIn) {
      navigate("/", { state: { autoRedirect: true } });
    }
  }, [isLoading, loggedIn, navigate]);

  useEffect(() => {
    if (loginMutation.isError) {
      navigate("/unauthorized");
    }
  }, [loginMutation.isError, navigate]);

  setTitle("Autenticando...");

  return (
    <Container>
      <Card>
        <Content>
          <LogosContainer>
            <img src={logoEgam} alt="eGAM" />
          </LogosContainer>
          {isLoading && (
            <>
              <Loading color={colors.loader.primary} height={80} width={80} />
              <Message>Autenticando...</Message>
            </>
          )}
        </Content>
      </Card>
    </Container>
  );
};

export default Login;
